<template>
  <v-card class="pa-3" height="330px">
    <v-card-title class="body-1">
      <span class="secondary--font font-weight-600">
        Tickets by Type
      </span>
      <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            size="20"
            class="pl-2 cursor-pointer"
            id="Tickets-by-types"
            >mdi-information-outline</v-icon
          >
        </template>
        <span>
          Unresolved ticket per service request Type.
        </span>
      </v-tooltip>
    </v-card-title>
    <div v-if="chartLoader" class="ticket-type-chart px-3 pr-5">
      <HorizontalBar
        :style="barStyles"
        :options="chartOptions"
        :chartdata="chartdata"
      />
    </div>
  </v-card>
</template>

<script>
import HorizontalBar from "@/components/charts/HorizontalBar.vue";
import { $dashboard } from "@/services/Index";

export default {
  components: {
    HorizontalBar,
  },
  data() {
    return {
      chartOptions: {},
      chartdata: {},
      chartRef: null,
      legendMarkup: null,
      chartLoader: false,
    };
  },

  computed: {
    barStyles() {
      let height = "";
      if (this.chartdata.datasets[0].data.length < 10) {
        height = "250px";
      }
      return {
        height,
      };
    },
  },

  mounted() {
    this.intializeGraph();
  },
  methods: {
    intializeGraph() {
      this.chartdata = {
        labels: [],
        datasets: [
          {
            fill: false,
            label: "",
            lineTension: 0.3,
            data: [],
            backgroundColor: [],
            borderColor: [],
            maxBarThickness: 15,
            hidden: false,
          },
        ],
      };
      this.chartOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          padding: 10,
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              var dataset =
                chart.config.data.datasets[tooltipItem.datasetIndex];
              return {
                backgroundColor: dataset.borderColor,
              };
            },
          },
        },
        hover: {
          mode: "nearest",
          intersect: false,
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
              ticks: {
                callback: function (value) {
                  return String(value).substr(0, 15);
                },
                fontSize: 14,
                fontColor: "black",
                stepSize: 10,
                min: 10,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
              ticks: {
                callback: function (value) {
                  return value;
                },
                fontSize: 14,
                fontColor: "black",
                stepSize: 10,
                beginAtZero: true,
              },
              position: "top",
            },
          ],
        },
      };
      this.getTicketByTypes();
    },

    /** it will generate random color for each ticket types bar */
    getRandomColor() {
      var letters = "0123456789ABCDEF".split("");
      var color = "#";
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /** get ticket by types from API's */
    async getTicketByTypes() {
      this.chartLoader = false;

      try {
        const response = await $dashboard.ticketByTypes({});
        if (response.data) {
          this.setDataInGraph(response.data);
          this.chartLoader = true;
        }
      } catch (error) {
        console.log("error==", error);
        this.chartLoader = true;
      }
    },

    /** setting ticket types data in bar chart */
    setDataInGraph(data) {
      this.chartdata.labels = [];
      this.chartdata.datasets[0].data = [];
      this.chartdata.datasets[0].backgroundColor = [];
      for (var key of Object.keys(data)) {
        this.chartdata.datasets[0].data.push(data[key]);
        let label = this.capitalizeFirstLetter(key);
        this.chartdata.labels.push(label);
        this.chartdata.datasets[0].backgroundColor.push(this.getRandomColor());
      }
      this.chartLoader = true;
    },
  },
};
</script>

<style lang="scss">
.ticket-type-chart {
  height: 250px !important;
  overflow-y: auto !important;
}
</style>
